export default "__VITE_ASSET__Ds4ZaRiK__"